export default [
  {
    id: 1,
    name: "Aragorn II Elessar Telcontar",
    image:
      "https://upload.wikimedia.org/wikipedia/en/thumb/3/35/Aragorn300ppx.png/170px-Aragorn300ppx.png",
  },
  {
    id: 2,
    name: "Django Freeman",
    image:
      "https://pbs.twimg.com/profile_images/1343818057425313793/6G8U2Doj_400x400.jpg",
  },
  {
    id: 3,
    name: "Enzo Gorlami",
    image:
      "http://polisharmy.pl/uploads/monthly_2018_05/a4a2787b3ed6ef86e6ba3b726bf175d2dcb548ee_full.jpg.7cc60a5d3afc22cb8d052764bc27803e.jpg",
  },
  {
    id: 4,
    name: "Kratos",
    image: "https://avatarfiles.alphacoders.com/132/thumb-1920-132539.jpg",
  },
];
